// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_text/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_text: ModuleSchema = {
  "id": "core_text",
  "uniqueId": "B3D_TEXT1",
  "createdAt": "2026-10-02T01:47:00Z",
  "updatedAt": "2026-10-28T14:58:33.153Z",
  "label": "Text Core",
  "description": "Parametric 3D Text, Embossing, and Engraving built from core_geometry/text.h",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_TEXT01",
    "text"
  ],
  "sliders": [
    {
      "key": "renderMode",
      "label": "Render Mode (0:Solid Text, 1:Plate + Embossed, 2:Engraved)",
      "min": 0,
      "max": 2,
      "default": 1,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontSize",
      "label": "Font Cap Height",
      "min": 10,
      "max": 60,
      "default": 25,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "textHeight",
      "label": "Text Extrusion Depth",
      "min": 0.5,
      "max": 8,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "letterSpacing",
      "label": "Letter Spacing Extra",
      "min": -10,
      "max": 30,
      "default": 0,
      "step": 1,
      "unit": "%",
      "enabled": true,
      "visible": true
    },
    {
      "key": "plateMargin",
      "label": "Plate Border Margin",
      "min": 2,
      "max": 15,
      "default": 5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "curveRadius",
      "label": "Curved Baseline Radius (0 = straight)",
      "min": 0,
      "max": 80,
      "default": 0,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "plateThickness",
      "label": "Plate Base Thickness",
      "min": 1,
      "max": 8,
      "default": 3,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Display Text",
      "default": "CAD 3D",
      "kind": "text",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family (28 Fonts)",
      "default": "roboto",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "text_plate",
      "label": "Supporting Base Plate",
      "default": "#1E293B",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "text_geometry",
      "label": "Extruded 3D Glyphs",
      "default": "#38BDF8",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_plate",
      "label": "Base Plate Assembly",
      "name": "Base Plate Assembly",
      "color": "#1E293B",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "text_plate",
          "label": "Supporting Base Plate",
          "name": "Supporting Base Plate",
          "groupId": 0,
          "colorKey": "text_plate",
          "defaultColor": "#1E293B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_text",
      "label": "3D Text Geometry Assembly",
      "name": "3D Text Geometry Assembly",
      "color": "#38BDF8",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "text_geometry",
          "label": "Extruded 3D Glyphs",
          "name": "Extruded 3D Glyphs",
          "groupId": 1,
          "colorKey": "text_geometry",
          "defaultColor": "#38BDF8",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Text & Plate"
    },
    {
      "id": "0",
      "label": "Download STL - Base Plate"
    },
    {
      "id": "1",
      "label": "Download STL - 3D Text Glyphs"
    }
  ]
};
